import { ShortcutHelper } from '@/services/helpers/ShortcutHelper'

export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const clerkAuth = useAuth()
  if (!clerkAuth.isSignedIn.value) {
    const token = localStorage.getItem('auth-token')
    if (token) {
      userStore.editable.token = token
    }
  }
  const currentTenant = localStorage.getItem('current-tenant-id')
  if (currentTenant) {
    userStore.editable.currentTenantId = currentTenant
  }
  const { isMobileDevice, isAppOrWebWithMobile, addDeepLinking, inviteToDownloadIfMobileBrowser } = useDeviceStore()
  isMobileDevice()
  isAppOrWebWithMobile()
  addDeepLinking()
  ShortcutHelper.init()
  inviteToDownloadIfMobileBrowser()
})
